'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Global error:', error);
  }, [error]);

  return (
    <html lang="en">
      <head>
        <title>Critical Error | 100xprompt</title>
        <meta name="description" content="A critical error occurred. Please refresh the page or contact support if the problem persists." />
      </head>
      <body>
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-900 via-black to-gray-900">
          <div className="text-center px-6 py-12 max-w-2xl">
            <div className="mb-8">
              <h1 className="text-6xl font-bold text-white mb-4">⚠️</h1>
              <h2 className="text-2xl font-semibold text-gray-300 mb-6">
                Critical Error
              </h2>
              <p className="text-gray-400 mb-8">
                We encountered a critical error. Please try refreshing the page or contact support if the problem persists.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={reset}
                className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-colors"
              >
                Try Again
              </button>
              <button
                onClick={() => window.location.href = '/'}
                className="px-6 py-3 bg-gray-800 hover:bg-gray-700 text-white font-medium rounded-lg transition-colors"
              >
                Go Home
              </button>
            </div>

            {error.digest && (
              <p className="mt-8 text-sm text-gray-500">
                Error ID: {error.digest}
              </p>
            )}
          </div>
        </div>
      </body>
    </html>
  );
}
